const MyTeamIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.2249 7.29999C6.7749 7.29999 8.0499 6.07499 8.0499 4.54999C8.0499 3.02499 6.7749 1.79999 5.2249 1.79999C3.6749 1.79999 2.3999 3.02499 2.3999 4.54999C2.3999 6.07499 3.6749 7.29999 5.2249 7.29999ZM5.2249 2.94999C6.1499 2.94999 6.9249 3.67499 6.9249 4.57499C6.9249 5.47499 6.1749 6.19999 5.2249 6.19999C4.2749 6.19999 3.5249 5.47499 3.5249 4.57499C3.5249 3.67499 4.2999 2.94999 5.2249 2.94999Z"
        fill="#9CA3AF"
      />
      <path
        d="M11.5 8.5C12.85 8.5 13.925 7.45 13.925 6.125C13.925 4.8 12.825 3.75 11.5 3.75C10.175 3.75 9.07495 4.8 9.07495 6.125C9.07495 7.45 10.175 8.5 11.5 8.5ZM11.5 4.9C12.225 4.9 12.8 5.45 12.8 6.15C12.8 6.85 12.225 7.4 11.5 7.4C10.775 7.4 10.2 6.85 10.2 6.15C10.2 5.45 10.775 4.9 11.5 4.9Z"
        fill="#9CA3AF"
      />
      <path
        d="M11.625 8.74998H11.4C10.65 8.74998 9.92495 8.97498 9.29995 9.34998C8.62495 8.44998 7.54995 7.84998 6.34995 7.84998H4.12495C2.07495 7.87498 0.449951 9.49998 0.449951 11.525V13.325C0.449951 13.8 0.824951 14.175 1.29995 14.175H14.725C15.2 14.175 15.6 13.775 15.6 13.3V12.7C15.575 10.525 13.8 8.74998 11.625 8.74998ZM1.57495 13.05V11.525C1.57495 10.125 2.72495 8.97498 4.12495 8.97498H6.34995C7.74995 8.97498 8.89995 10.125 8.89995 11.525V13.05H1.57495ZM14.45 13.05H9.99995V11.525C9.99995 11.125 9.92495 10.725 9.79995 10.35C10.25 10.025 10.8 9.87498 11.375 9.87498H11.6C13.15 9.87498 14.425 11.15 14.425 12.7V13.05H14.45Z"
        fill="#9CA3AF"
      />
    </svg>
  );
};

export default MyTeamIcon;
